import { render, staticRenderFns } from "./VxForm.vue?vue&type=template&id=384e60b4&scoped=true&"
import script from "./VxForm.vue?vue&type=script&lang=js&"
export * from "./VxForm.vue?vue&type=script&lang=js&"
import style0 from "./VxForm.vue?vue&type=style&index=0&id=384e60b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e60b4",
  null
  
)

export default component.exports